module.exports = __webpack_public_path__ + "img/excel-example.png";